/* eslint-disable react/jsx-indent */
/* eslint-disable no-unused-vars */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { TableAlias } from 'tabler-icons-react';
import { ScrollArea } from '@mantine/core';
import { assetPrefix, renderNumber } from '../../utilities/general';
import SelectDropdown from './SelectDropDown';
import styles from './styles.module.css';

const CommonTable = (props) => {
  const { title, data, dropdownProps } = props;
  return (
    <div className={`${styles.hotColdWallet} px-2.5 py-4`}>
      <div className={`${styles.HeadingText}`}>
        <SelectDropdown {...dropdownProps} />
      </div>
      <div className={`${styles.HotColdListingHeader} pt-2.5`}>
        <div className={`grid items-start transition-transform cursor-pointer text-right pb-2 ${styles.HotColdHeadingGrid} ${styles.HotColdHeading}`}>
          <div className="text-left">Asset</div>
          <div>Quantity</div>
          <div>Value</div>
        </div>
      </div>
      {data?.items?.length === 0 ? (
        <div className="h-[74%] flex items-center justify-center gap-3">
          <TableAlias size={22} strokeWidth={1.5} color="#A3AED0" />
          <span className="text-sm font-normal text-center">{title === 'Staking' ? 'No Assets Staked' : 'No Data Found'}</span>
        </div>
      ) : (
        <ScrollArea style={{ height: '74%' }} type="never" scrollbarSize={5} scrollHideDelay={200}>
          <div className={`${styles.rowContainerMain}`}>
            {!!data?.items?.length && data?.items.map((asset, index) => (
              <div className={`${styles.rowContainer} ${index !== data?.items?.length - 1 ? 'border-b border-[#CECECE] pb-3' : ''}`}>
                <div className={`grid items-start transition-transform text-right ${styles.HotColdrowGrid} ${styles.rowText}`}>
                  <div className="flex gap-1">
                    <div>
                      <img
                        src={asset?.icon ? asset?.icon : `${assetPrefix}/images/coinBase.svg`}
                        alt="CoinBase"
                        className="max-w-fit w-4 h-4 rounded-full"
                      />
                    </div>
                    <div>
                      {asset.asset}
                    </div>
                  </div>
                  <div className="!font-normal">{renderNumber(asset?.quantity)}</div>
                  <div className="!font-normal">{renderNumber(asset.totalValueUsd, true)}</div>
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      )}
    </div>
  );
};

export default CommonTable;
